export default async () => {

	//***LOGIN FORMS***//
    let loginRadioBtns = document.querySelectorAll('.login-radio') as NodeListOf<HTMLInputElement>;
    let loginForms = document.querySelectorAll('.login-form')  as NodeListOf<HTMLFormElement>;
	let loginFormWrap = document.querySelector('#login-wrapper') as HTMLElement;
	let loginDeskToggle = document.querySelector('#login-desktop-btn') as HTMLElement;

	document.addEventListener('DOMContentLoaded', () => {
		loginDeskToggle.classList.remove('login-open');
		loginFormWrap.classList.remove('login-open');
		document.querySelector('body').classList.remove('menu-open');
	});

	window.onload = function() {
		let header = document.querySelector('.site-header') as HTMLElement;
		let windowHeight = window.innerHeight;
		let headerHeight = header.offsetHeight;

		loginFormWrap.style.maxHeight = (windowHeight - headerHeight) + 'px';
	}

	var loginOpenObserver = new MutationObserver(function(mutationsList) {
		for (var mutation of mutationsList) {
			if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
				if (loginFormWrap.classList.contains('login-open')) {
					document.body.classList.add('login-open');
					document.documentElement.classList.add('login-open');
				} else {
					document.body.classList.remove('login-open');
					document.documentElement.classList.remove('login-open');
				}
			}
		}
	});

	loginOpenObserver.observe(loginFormWrap, { attributes: true });

    //Add event listener to each of the radio buttons
    loginRadioBtns.forEach(radioBtn => {
      radioBtn.addEventListener('change', showAndHideForms);
    });

    //Toggle hide class to show and hide login forms based on radio buttons checked
    function showAndHideForms(e) {	
		var index = Array.from(loginRadioBtns).indexOf(e.target);
		
		for(var i = 0; i < loginRadioBtns.length; i++) {
			if(i === index) {
				loginForms[i].classList.remove('hide');
			} else {
				loginForms[i].classList.add('hide');
			}
		}
    }
    //***END LOGIN FORMS***//

};